function Tools() {

	this.setClass = function(e, c) {
		var cc = null;
		if (typeof e.className === 'undefined') {
			cc = e.getAttribute('class');
			if (cc.indexOf(c) < 0) {
				if (c.length > 0) {
					c = cc + ' ' + c;
				}

				e.setAttribute('class', c);
			}
		} else {
			cc = e.className;
			if (cc.indexOf(c) < 0) {
				if (c.length > 0) {
					c = cc + ' ' + c;
				}

				e.className = c;
			}
		}
	};

	this.removeClass = function(e, c) {
		var nc = null;
		var reg = new RegExp('(\\s|^)+' + c.replace('-', '\\-') + '(\\s|$)+');
		if (typeof e.className === 'undefined') {
			nc = e.getAttribute('class').replace(reg, ' ');
			e.setAttribute('class', nc);
		} else {
			e.className = e.className.replace(reg, ' ');
		}
	};

}

module.exports = new Tools();
